export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewStatus(state, { payload }) {
    state.statuses = [...state.statuses, ...[payload]];
  },

  delProperty(state, { property }) {
    state.statuses = state.statuses.filter(el => el.id !== property);
  },
};
